import React, { Component } from "react";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import WidgetGroupSection from "../component/section/widgetgroup";

class AboutPage extends Component {
  render() {
    return (
      <div>
        <Header />
        <PageHeader title={"About"} />
        <section className="blog-section padding-tb">
          <div className="container">
            <div className="main-blog">
              <div className="row">
                <div className="col-lg-8 col-12">
                  <div className="blog-wrapper">
                    <div className="post-item">
                      <div className="post-item-inner">
                        <div className="post-content">
                          <h3>About Tegal</h3>
                          <p>
                            Tegal is a premier matchmaking service dedicated to
                            connecting individuals from diverse backgrounds,
                            tribes, and religions for meaningful relationships
                            that lead to marriage in Nigeria. Our platform welcomes
                            individuals from all over the country, fostering a
                            vibrant community that celebrates love, diversity,
                            and unity.
                          </p>

                          <div className="content">
                            <h3>Our Vision</h3>
                            <p>
                              Our vision is to become the leading matchmaking
                              platform in Africa and beyond, renowned for our
                              commitment to quality, inclusivity, and the
                              success of our members. We envision a world where
                              love knows no borders, and everyone has the
                              opportunity to find their perfect match.
                            </p>
                          </div>
                          <div className="content">
                            <h3>Our Mission</h3>
                            <p>
                              Our mission is to provide a safe, supportive, and
                              personalized matchmaking experience that empowers
                              individuals to find meaningful relationships and
                              lasting love. We are dedicated to:
                              <ul>
                                <li>
                                  - Fostering a community that values diversity,
                                  inclusivity, and respect
                                </li>
                                <li>
                                  - Providing a platform that is secure, easy to
                                  use, and accessible to all
                                </li>
                                <li>
                                  - Offering personalized matchmaking services
                                  that cater to the unique needs and preferences
                                  of our members
                                </li>
                                <li>
                                  - Celebrating the success stories of our
                                  members and providing ongoing support to help
                                  them build strong, healthy relationships
                                </li>
                              </ul>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="post-item post-slider">
                      <div className="post-item-inner">
                        <div className="post-thumb">
                          <div className="blog-slider">
                            <Swiper
                              spaceBetween={30}
                              centeredSlides={true}
                              autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                              }}
                              navigation={{
                                prevEl: ".blog-slider-prev",
                                nextEl: ".blog-slider-next",
                              }}
                              loop={true}
                              modules={[Autoplay, Navigation]}
                              className="mySwiper"
                            >
                              <SwiperSlide>
                                <img
                                  src="assets/images/blog/03.jpg"
                                  alt="blog"
                                />
                              </SwiperSlide>
                              <SwiperSlide>
                                <img
                                  src="assets/images/blog/02.jpg"
                                  alt="blog"
                                />
                              </SwiperSlide>
                              <SwiperSlide>
                                <img
                                  src="assets/images/blog/01.jpg"
                                  alt="blog"
                                />
                              </SwiperSlide>
                            </Swiper>
                            <div className="blog-slider-next">
                              <i className="icofont-play"></i>
                            </div>
                            <div className="blog-slider-prev">
                              <i className="icofont-play"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  <aside className="mt-5 mt-lg-0">
                    <WidgetGroupSection />
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterSection />
      </div>
    );
  }
}

export default AboutPage;
